'use strict';

import angular from 'angular';
import Main from './questions.controller';

export default angular.module('aperamApp.borne.questions', [])
  .controller('QuestionsController', Main)
  .name;


// WEBPACK FOOTER //
// ./client/app/borne/questions/index.js